// import { getStoredToken } from "../constants/auth"

import { Server } from "../constants/server.js"

const encodePathSegment = (segment) => encodeURIComponent(String(segment ?? ''))

const encodeFilePath = (filePath = '') => {
    return String(filePath)
        .split(/[\\/]+/)
        .filter((segment) => segment && segment !== '.' && segment !== '..')
        .map(encodePathSegment)
        .join('/')
}

const buildApiUrl = (path, ...segments) => {
    const BaseUrl = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/${path}`)
    const safeSegments = segments.join('/')
    return `${BaseUrl}/${safeSegments}`
}

export const getSecuredFileUrl = (filePath) => {
    let url = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/${encodeFilePath(filePath)}`)
    return url?.href?.toString()
}

export const getPreview = (file) => {
    if (/image\/[a-z+.-]+/.test(file.type)) {
        return file.preview
    }
    switch (file.type) {

        case "application/pdf":
            return "/icons/filetypes/pdf.svg"
        case "application/ai":
            return "/icons/filetypes/ai.svg"
        case "application/postscript":
            return "/icons/filetypes/ai.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}
export const getFilePath = (name, project_id) => {
    return buildApiUrl('file', encodePathSegment(project_id), encodeFilePath(name))
}
export const getFilePathForView = (name, project_id) => {
    return buildApiUrl('file/read', encodePathSegment(project_id), encodeFilePath(name))
}

export const getAdditionalQuotationFile = (id) => {
    return buildApiUrl('item/additional-quotation', encodePathSegment(id), 'preview')
}

export const getFileExtension = (file = '') => file.split('?')[0].split('#')[0].split('.').pop()?.toLowerCase()

export const IMAGE_PREVIEW_TYPES = ["svg", "png", "jpg", "jpeg", "webp", "gif"]

export const isImagePreviewType = (type) => IMAGE_PREVIEW_TYPES.includes(type?.toLowerCase())

const PREVIEWABLE_FILE_TYPES = ["pdf", ...IMAGE_PREVIEW_TYPES]

export const isShowable = (file) => {
    const extention = getFileExtension(file)
    return PREVIEWABLE_FILE_TYPES.includes(extention)
}

export const getPreviewUrl = (file, project_id) => {
    const extention = getFileExtension(file)
    switch (extention) {
        case "svg":
            return getFilePath(file, project_id)
        case "png":
            return getFilePathForView(file, project_id)
        case "jpg":
            return getFilePathForView(file, project_id)
        case "jpeg":
            return getFilePathForView(file, project_id)
        case "xlsx":
            return "/icons/filetypes/xlsx.svg"
        case "csv":
            return "/icons/filetypes/xlsx.svg"
        case "ai":
            return "/icons/filetypes/ai.svg"
        case "pdf":
            return "/icons/filetypes/pdf.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}

export const getCmsLanguageFlagUrl = (language) => {
    if (!language) return ''
    const [country, lang = null] = language.split('_')
    return Server.getPublicFileUrl(`upload/flag/${lang ?? country}.png`)
}
